import "./form.css.ts.vanilla.mjs";
var _ = "p273__form-84d1_fc9ba7c36__17t7e1n0";
export {
  _ as formStyle
};
//# sourceMappingURL=form.mjs.map
